import React, { useMemo, useState } from "react";
import { RotateCcw } from "lucide-react";
import { getAllStatuses, setItemStatus, resetStatuses } from "../../utils/courseLocalProgress";

interface LessonQuizProps {
  questions: { question: string; answer: string }[];
  scopeId: string;
}

const LessonQuiz: React.FC<LessonQuizProps> = ({ questions, scopeId }) => {
  const [index, setIndex] = useState(0);
  const [revealed, setRevealed] = useState(false);
  const [statuses, setStatuses] = useState<Record<string, boolean>>(() =>
    getAllStatuses("quiz", scopeId)
  );

  const understoodCount = useMemo(
    () => questions.filter((q) => statuses[q.question]).length,
    [questions, statuses]
  );

  if (questions.length === 0) return null;
  const item = questions[index];

  const advance = () => {
    setRevealed(false);
    setIndex((prev) => (prev + 1) % questions.length);
  };

  const mark = (understood: boolean) => {
    setItemStatus("quiz", scopeId, item.question, understood);
    setStatuses((prev) => ({ ...prev, [item.question]: understood }));
    advance();
  };

  const handleReset = () => {
    resetStatuses("quiz", scopeId);
    setStatuses({});
  };

  return (
    <div className="lesson-quiz-interactive">
      <div className="lesson-flashcards__progress">
        <span>
          {understoodCount} of {questions.length} marked understood
        </span>
        <button type="button" onClick={handleReset} className="lesson-flashcards__reset">
          <RotateCcw aria-hidden="true" size={14} /> Reset progress
        </button>
      </div>

      <div className="lesson-quiz-interactive__card">
        <p className="lesson-quiz-interactive__count">
          Question {index + 1} of {questions.length}
        </p>
        <h3>{item.question}</h3>
        {revealed ? (
          <p className="lesson-quiz-interactive__answer">{item.answer}</p>
        ) : (
          <button type="button" className="lesson-flashcards__review" onClick={() => setRevealed(true)}>
            Reveal answer
          </button>
        )}
      </div>

      {revealed && (
        <div className="lesson-flashcards__actions">
          <button type="button" onClick={() => mark(false)} className="lesson-flashcards__review">
            Need review
          </button>
          <button type="button" onClick={() => mark(true)} className="lesson-flashcards__known">
            I understood this
          </button>
        </div>
      )}
    </div>
  );
};

export default LessonQuiz;
